import React, { Fragment } from 'react';

const DotSeparator = () => <Fragment>&nbsp;&bull;&nbsp;</Fragment>;

export default DotSeparator;
